import { UPDATE_ANALYTICS_CONSENT } from 'api/analytics/update-analytics-consent'
import { analyticsClient, sendAnalyticsOperation } from 'shared/analytics'
import { CONSENT_POLICY_VERSION } from '../constants'
import type { ConsentCategories } from '../types'

/**
 * Hands the cookie choice to the backend ahead of the next events batch
 * (FE-330). The backend snapshots the consent into every event it journals
 * and delivers nothing to GA4 or Meta for a subject without an answer, so the
 * analytics client sends `updateAnalyticsConsent` before `trackEvents`, for
 * whoever the requests go out as (guest session or user).
 */
export const reportConsent = ({ analytics, marketing }: ConsentCategories) =>
  analyticsClient.runBefore('consent', options =>
    sendAnalyticsOperation(
      UPDATE_ANALYTICS_CONSENT,
      {
        input: { analytics, marketing, policyVersion: CONSENT_POLICY_VERSION }
      },
      options
    )
  )
